import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'OOPBuy Spreadsheet Schuhe Guide',
    desc: 'Entdecke die besten Sneaker, Lederschuhe und mehr in der Schuhe-Kategorie.',
    image: 'https://readdy.ai/api/search-image?query=Single%20premium%20white%20leather%20sneaker%20elegantly%20positioned%20on%20a%20textured%20cream%20ceramic%20surface%20with%20soft%20warm%20directional%20side%20lighting%20creating%20gentle%20sculptural%20shadows%20minimalist%20product%20photography%20refined%20luxury%20aesthetic%20clean%20modern%20composition%20muted%20neutral%20tones&width=800&height=500&seq=article-card-shoes&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-schuhe',
    tag: 'Schuhe',
  },
  {
    title: 'OOPBuy Spreadsheet Sicherheit',
    desc: 'Alles über Datenschutz, Betrugserkennung und sichere Nutzung der Plattform.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20desk%20setup%20with%20a%20small%20glass%20shield%20paperweight%20catching%20warm%20afternoon%20light%20beside%20a%20notepad%20and%20pen%20clean%20white%20desktop%20surface%20soft%20natural%20window%20light%20creating%20gentle%20reflections%20serene%20secure%20atmosphere%20neutral%20warm%20beige%20tones%20editorial%20style&width=800&height=500&seq=article-card-sicherheit&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-sicherheit',
    tag: 'Sicherheit',
  },
  {
    title: 'OOPBuy Spreadsheet für Anfänger',
    desc: 'Schritt-für-Schritt Anleitung für einen erfolgreichen Start mit der Plattform.',
    image: 'https://readdy.ai/api/search-image?query=Open%20blank%20notebook%20with%20a%20single%20elegant%20pen%20resting%20on%20it%20placed%20on%20a%20light%20wooden%20table%20with%20soft%20morning%20sunshine%20casting%20gentle%20shadows%20a%20small%20potted%20succulent%20nearby%20beginner%20friendly%20welcoming%20atmosphere%20minimalist%20scandinavian%20interior%20warm%20natural%20light%20clean%20composition&width=800&height=500&seq=article-card-anfaenger&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-anfaenger',
    tag: 'Anfänger',
  },
  {
    title: 'OOPBuy Spreadsheet Vergleich 2026',
    desc: 'Detaillierter Vergleich mit Alternativen – finde die beste Lösung für dich.',
    image: 'https://readdy.ai/api/search-image?query=Two%20identical%20minimal%20white%20display%20stands%20side%20by%20side%20on%20a%20clean%20surface%20each%20presenting%20a%20different%20fashion%20accessory%20soft%20balanced%20studio%20lighting%20creating%20subtle%20distinction%20between%20items%20professional%20comparison%20photography%20concept%20neutral%20warm%20background%20elegant%20editorial%20style&width=800&height=500&seq=article-card-vergleich&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-vergleich',
    tag: 'Vergleich',
  },
  {
    title: 'OOPBuy Spreadsheet Hoodies Guide',
    desc: 'Die besten Hoodies und Sweater übersichtlich im OOPBuy Spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20quality%20folded%20heather%20grey%20hoodie%20neatly%20arranged%20on%20a%20light%20linen%20fabric%20surface%20with%20soft%20diffused%20window%20light%20creating%20gentle%20texture%20highlights%20minimalist%20apparel%20photography%20warm%20neutral%20tones%20cozy%20aesthetic%20clean%20product%20styling%20editorial%20fashion%20catalog%20look&width=800&height=500&seq=article-card-hoodies&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Hoodies',
  },
  {
    title: 'OOPBuy Spreadsheet T-Shirts Guide',
    desc: 'Zeitlose Basics und angesagte Designs für jeden Geschmack entdecken.',
    image: 'https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20t%20shirt%20elegantly%20folded%20on%20a%20smooth%20pale%20stone%20surface%20with%20gentle%20morning%20light%20casting%20soft%20elongated%20shadows%20minimalist%20fashion%20photography%20clean%20refined%20aesthetic%20subtle%20warm%20cream%20undertones%20premium%20apparel%20presentation%20editorial%20product%20shot&width=800&height=500&seq=article-card-tshirts&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'T-Shirts',
  },
  {
    title: 'OOPBuy Spreadsheet Jacken Guide',
    desc: 'Von Übergangsjacken bis Wintermodelle – alle Jacken im Überblick.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20tailored%20camel%20colored%20jacket%20draped%20elegantly%20over%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20cream%20wall%20backdrop%20with%20gentle%20side%20lighting%20creating%20subtle%20depth%20and%20texture%20sophisticated%20product%20photography%20warm%20neutral%20palette%20refined%20editorial%20fashion%20aesthetic&width=800&height=500&seq=article-card-jackets&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Jacken',
  },
  {
    title: 'OOPBuy Spreadsheet Accessoires Guide',
    desc: 'Uhren, Schmuck und mehr – Accessoires clever vergleichen und finden.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20watch%20with%20leather%20strap%20placed%20on%20a%20smooth%20marble%20surface%20alongside%20a%20simple%20bracelet%20with%20soft%20natural%20light%20creating%20gentle%20reflections%20sophisticated%20accessories%20photography%20clean%20composition%20warm%20neutral%20tones%20refined%20product%20styling%20editorial%20luxury%20aesthetic&width=800&height=500&seq=article-card-accessories&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Accessoires',
  },
  {
    title: 'OOPBuy Spreadsheet Taschen Guide',
    desc: 'Stylische Taschen und Rucksäcke – übersichtlich und vergleichbar.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20elegantly%20positioned%20on%20a%20clean%20light%20wooden%20surface%20with%20soft%20natural%20window%20light%20creating%20gentle%20shadows%20and%20texture%20highlights%20minimalist%20bag%20photography%20warm%20neutral%20tones%20refined%20product%20styling%20clean%20editorial%20composition%20sophisticated%20aesthetic&width=800&height=500&seq=article-card-bags&orientation=landscape',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Taschen',
  },
];

export default function ArticleGridSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wider mb-2">
            SEO Ratgeber
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            OOPBuy Spreadsheet Artikel &amp; Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-2xl mx-auto">
            Entdecke unsere ausführlichen Ratgeber und erfahre alles über OOPBuy Spreadsheet – von Kategorien über Sicherheit bis zu Expertentipps.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.tag}
              to={article.link}
              className="group block bg-white rounded-lg overflow-hidden cursor-pointer hover:bg-background-50 transition-all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-white/90 text-foreground-900 rounded-full">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  Weiterlesen
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-foreground-900 text-white rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Alle Guides ansehen
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}